import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import DataTable from "../../../common/DataTable";
import SearchableSingleSelectDropdown from "../../../common/SearchableDropdown";
import {
  GetAssignedToReviewerList 
} from '../../../services/RecordReviewerAPI';
import {
  GetAssignedToHistorianList 
} from '../../../services/HistorianAPI';

import {
  GetAssignedTo,
} from "../../../services/EditorWorkFlowAPI";

import {
  updateAssignedMyToDo,
  GetAssignMyToDoByScheduleId,
  GetDoctorUserMappingDetails,
} from "../../../services/AppointmentsAPI";
import {
  GetAssignedToList,
} from "../../../services/TranscriberAPI";
import Snackbar from "../../../common/Snackbar";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";

const HEADERS: any[] = [
  { key: "patientName", label: "Patient Name" },
  { key: "qmeDoctorName", label: "Doctor Name" },
  { key: "caseId", label: "Case Id" },
];

const USERMAPPINGHEADER: any[] = [
  { key: "doctorDetails", label: "Doctor Details" },
  { key: "historian", label: "Historian" },
  { key: "recordReviewer", label: "Record Reviewer" },
  { key: "editor", label: "Editor" },
  { key: "transcriber", label: "Transcriber" },
];

const AssignMyTodo: React.FC<any> = ({
  userData,
  SelectedRowsDataTo,
  showModalNew,
  closeModel,
  onSaveSuccess,
  onClose,
}) => {
  const [editorUserId, setEditorUserId] = useState(0);
  const [HistorianUserId, setHisorianUserId] = useState(0);
const [recordReviewerUserId, setRecordReviewerUserId] = useState(0);
    const [transcriberUserId, setTranscriberUserId] = useState(0);
  const [EditorOptions, setEditorOptions] = useState<any[]>([]);
   const [HistorianOptions, setHistorianOptions] = useState<any[]>([]);
    const [RecordReviewerOptions, setRecordReviewerOptions] = useState<any[]>([]);
     const [TranscriberOptions, setTranscriberOptions] = useState<any[]>([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [showEventModal, setShowEventModal] = useState(false);
const [data, setData] = useState<any[]>([]);
useEffect(() => {
  const loadInitialData = async () => {
    try {
      // Load all dropdowns first
      await Promise.all([
        fetchEditorListData(),
        fetchRecordReviewerListData(),
        fetchTanscriberListData(),
        fetchHistorianListData(),
      ]);

      // Then preselect if single schedule id
      await fetchAssignMyTodoData();
    } catch (error) {
      console.error("Error loading data:", error);
    }
  };

  loadInitialData();
}, [userData]);

  const fetchEditorListData = async () => {
    try {
      const response = await GetAssignedTo();
    
      if (response?.isSuccess && Array.isArray(response.result)) {
        const formattedOptions = response.result.map((item: any) => ({
          value: item.userId,
          label: item.fullname,
        }));

        setEditorOptions(formattedOptions);       
      } else {
        setEditorOptions([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setEditorOptions([]);
    }
  };
   const fetchRecordReviewerListData = async () => {
      try {
        const response = await GetAssignedToReviewerList(Number(loggedInUserid));
        if (response?.isSuccess && Array.isArray(response.result)) {
          const formattedOptions = response.result.map((item: any) => ({
            value: item.userId,
            label: item.fullName,
          }));
          setRecordReviewerOptions(formattedOptions);
        
        } else {
          setRecordReviewerOptions([]);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setRecordReviewerOptions([]);
      }
    };   
     const fetchTanscriberListData = async () => {
        try {
          const response = await GetAssignedToList();
    
          if (response?.isSuccess && Array.isArray(response.result)) {
            const formattedOptions = response.result.map((item: any) => ({
              value: item.userId,
              label: item.fullName,
            }));
    
            setTranscriberOptions(formattedOptions);
           
          } else {
            setTranscriberOptions([]);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
          setTranscriberOptions([]);
        }
      };    
    
   const fetchHistorianListData = async () => {
      try {
        const response = await GetAssignedToHistorianList(Number(loggedInUserid));
        if (response?.isSuccess && Array.isArray(response.result)) {
          const formattedOptions = response.result.map((item: any) => ({
            value: item.userId,
            label: item.fullName,
          }));
          setHistorianOptions(formattedOptions);
         
        } else {
          setHistorianOptions([]);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setHistorianOptions([]);
      }
    };


 const fetchAssignMyTodoData = async () => {
  try {
    const subjectQmeScheduleIDs = userData
      ?.map((item: any) => item.subjectqmescheduleid)
      .filter((id: any) => id != null);

    // Multiple rows selected -> no preselection
    if (
      !subjectQmeScheduleIDs ||
      subjectQmeScheduleIDs.length !== 1
    ) {
      setEditorUserId(0);
      setHisorianUserId(0);
      setRecordReviewerUserId(0);
      setTranscriberUserId(0);
      return;
    }

    const scheduleId = subjectQmeScheduleIDs[0];

    const data =
      await GetAssignMyToDoByScheduleId(scheduleId);

    
      setEditorUserId(
        Number(data.editorAssignedUserID) || 0
      );

      setHisorianUserId(
        Number(data.historianAssignedUserID) || 0
      );

      setRecordReviewerUserId(
        Number(data.rorAssignedUserID) || 0
      );

      setTranscriberUserId(
        Number(data.transcriberAssignedUserID) || 0
      );
    
  } catch (error) {
    console.error(
      "Error fetching change staff data:",
      error
    );
  }
};
  const handleSave = async () => {
    const subjectQmeScheduleIDNew = userData
      ?.map((item: any) => item.subjectqmescheduleid)
      .filter((id: any) => id != null)
      .join(",");
    const payload = {
      subjectQmeScheduleIDs: subjectQmeScheduleIDNew,
      editorUserId: Number(editorUserId),
      editorAssignedDate: null,
      editorComments: "",
      TranscriberUserId : Number(transcriberUserId),
      TranscriberDate: null,
      TranscriberComments: "",
      HistoryUserId : Number(HistorianUserId),
      HistoryComments: "",
      p_roruserid: Number(recordReviewerUserId),
      p_rorassigneddate: null,
      p_rorcomments: "",
      modifiedBy: Number(loggedInUserid),
    };
    try {
      const response = await updateAssignedMyToDo(payload);
      if (response.id !== 0) {
        setSnackbarMessage("Changed Staff successfully.");
        setError("success");
        setSnackbarOpen(true);
        setTimeout(() => {
              onClose();
          onSaveSuccess();
        }, 800);
      } else {
        setSnackbarMessage(
          response.message || "Failed to save  Change Staff."
        );
        setError("error");
        setSnackbarOpen(true);
      }
    } catch (error: any) {
      console.error("Error while updating change staff:", error);
      setSnackbarMessage(error.message);
      setError("error");
      setSnackbarOpen(true);
    }
  };

  const handleCancel = () => {
   setEditorUserId(0);
    setHisorianUserId(0);
    setRecordReviewerUserId(0);
    setTranscriberUserId(0);
  };
const handlePopup = async () => {
  try {
      const doctorIds = userData
      ?.map((item: any) => item.doctorId)
      .filter((id: any) => id != null)
      .join(",");

    const response =
      await GetDoctorUserMappingDetails(doctorIds);

    if (response) {
      setData([response]);
    }

    setShowEventModal(true);

  } catch (error) {
    console.error(
      "Error fetching doctor mapping:",
      error
    );
  }
};

const handleClosePopup = () => {
    setShowEventModal(false);   
  };
  return (
    <>
      <div className=" d-flex flex-column h-100">
        <Snackbar
          open={snackbarOpen}
          message={snackbarMessage}
          onClose={() => setSnackbarOpen(false)}
          severity={error}
        />

        {/* <Row>
          <div>
            {SelectedRowsDataTo?.length > 1 ? (
              <>
                To whom do you want to assign selected{" "}
                <span style={{ color: "#6bb3d4", margin: "0 4px" }}>
                  {SelectedRowsDataTo?.length}
                </span>
                case(s)?
              </>
            ) : (
              <b>To whom do you want to assign below case(s)?</b>
            )}
          </div>
        </Row> */}
        {/* <Row className="mt-4">
          {SelectedRowsDataTo?.length === 1 && (
            <DataTable headers={HEADERS} rows={editorData} isLogTable={false} />
          )}
        </Row> */}
        <Row>
            <Col
            sm={6}
            className="selection_dropdown selection_dropdownnew mt-4"
          >
            <SearchableSingleSelectDropdown
              label="Historian(s)"
              name="historianUserId"
            //   required={true}
              value={HistorianUserId}
              options={HistorianOptions}
              onChange={(e) => setHisorianUserId(Number(e.target.value))}
            />
          </Col>
           <Col
            sm={6}
            className="selection_dropdown selection_dropdownnew mt-4"
          >
            <SearchableSingleSelectDropdown
              label="Record Reviewer(s)"
              name="recordReviewerUserId"
            //   required={true}
              value={recordReviewerUserId}
              options={RecordReviewerOptions}
              onChange={(e) => setRecordReviewerUserId(Number(e.target.value))}
            />
          </Col>
          
        </Row>
<Row>
    <Col
            sm={6}
            className="selection_dropdown selection_dropdownnew mt-4"
          >
            <SearchableSingleSelectDropdown
              label="Editor(s)"
              name="editorUserId"
            //   required={true}
              value={editorUserId}
              options={EditorOptions}
              onChange={(e) => setEditorUserId(Number(e.target.value))}
            />
          </Col>
           <Col
            sm={6}
            className="selection_dropdown selection_dropdownnew mt-4"
          >
            <SearchableSingleSelectDropdown
              label="Transcriber(s)"
              name="transcriberUserId"
            //   required={true}
              value={transcriberUserId}
              options={TranscriberOptions}
              onChange={(e) => setTranscriberUserId(Number(e.target.value))}
            />
          </Col>
</Row>
        <Row id="team-form-buttons" className="bottom-fixed-btn mt-auto">
          <Col md={6} className="d-flex justify-content-start mb-0 ">
              {/* <Button
                              className="d-flex align-items-center"
                              style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: "10px",
                                fontSize: "22px",
                              }}
                              onClick={handlePopup}
                            >
                              <span className="material-icons reset_ic0">
                                restart_alt  
                              </span>
                               
                            </Button>   */}
                            <Button  onClick={handlePopup}
                             type="button" className="btn d-flex align-items-center btn-primary">
                              <span className="material-icons mr-2">alt_route</span>Doctor - User Mapping
                              </Button>
 
                 
                </Col>
          <Col md={6} className="d-flex justify-content-end mb-0 px-0 pe-0">
            <Button
              variant="outline-info"
              className="d-flex align-items-end"
              onClick={handleCancel}
            >
              <span className="material-icons mr-2">close</span> Cancel
            </Button>

            <Button
              variant="primary"
              className="ms-3 d-flex align-items-center"
              onClick={handleSave}
            >
              <span className="material-icons mx-1">save</span> Save
            </Button>
          </Col>
        </Row>

          <Modal
                    show={showEventModal}
                    onHide={handleClosePopup}
                    size="lg"
                    className="app-detail recordList"
                  >
                    <Modal.Header closeButton className="d-flex m-1 p-1">
                      <Modal.Title className="fw-bold text-left modelheading offcanvas-title d-flex align-items-center">
                        <span className="appointment_title_modal">Doctor - User Mapping</span>
                     
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-left">                    
                        <DataTable
                          headers={USERMAPPINGHEADER}
                          rows={data}
                        />                      
                    </Modal.Body>
                  </Modal>
      </div>
    </>
  );
};

export default AssignMyTodo;
